import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, ThemeProvider } from '@/context';
import { Router } from '@/router';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0, // Use 0 for now, adjust in the future when API is stable enough
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <ThemeProvider>
                    {/* Region, tenant and API providers are mounted inside the
                        router (see AppProviders) — the tenant context reads the
                        matched route. */}
                    <Router />
                    <Toaster />
                </ThemeProvider>
            </AuthProvider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}

export default App;
